export default "__VITE_ASSET__CakeB8cV__"